import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=a2550e36"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports